import { createFileRoute, redirect } from "@tanstack/react-router";
import { surfaceToHome, tryGetProfile } from "@core/auth";
import { LoginScreen } from "@modules/account/views";

interface LoginSearch {
  /** Deep link a guard bounced us off; forwarded to the login request as `next`. */
  next?: string;
}

// The app entry IS the login screen (served at "/", no "/login" detour). Two guard duties:
//   1. Rehydrate — if the refresh cookie is still valid, /me returns the profile and we send an
//      already-authenticated visitor to their home instead of showing login on reload.
//   2. Capture `?next=` so a post-login redirect can honor the originally requested path.
export const Route = createFileRoute("/")({
  validateSearch: (search: Record<string, unknown>): LoginSearch => ({
    next: typeof search.next === "string" ? search.next : undefined,
  }),
  beforeLoad: async ({ context }) => {
    const profile = await tryGetProfile(context.queryClient);
    if (profile) {
      throw redirect({ to: surfaceToHome(profile.default_surface) });
    }
  },
  component: LoginRoute,
});

function LoginRoute() {
  const { next } = Route.useSearch();
  return <LoginScreen next={next} />;
}
